(() => {
  'use strict';
  if (window.__ingoElectionPriceDisplay) return;
  window.__ingoElectionPriceDisplay = true;
  const TOKEN = 'J979H';
  const AMOUNT = 8900;
  const END = Date.parse('2026-10-28T00:00:00+02:00');
  const ROOT = '.limoniapps-discountninja-productprice-replaced';
  const BADGE = '.limoniapps-discountninja-badge';
  let config = {};
  try { config = JSON.parse(document.getElementById('ingo-election-price-config').textContent); } catch (_) {}
  const variants = new Map((config.variants || []).map(v => [String(v.id), v]));
  const currency = document.documentElement.getAttribute('data-currency') || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active);
  const allowed = () => Date.now() < END && currency === 'ILS';
  const minor = raw => {
    if (typeof raw !== 'string' || !/^\d+(?:\.\d{1,2})?$/.test(raw)) return null;
    const parts = raw.split('.');
    const result = Number(parts[0]) * 100 + Number((parts[1] || '').padEnd(2, '0'));
    return Number.isSafeInteger(result) ? result : null;
  };
  const money = value => (value / 100).toLocaleString('en-US', { minimumFractionDigits: value % 100 ? 2 : 0, maximumFractionDigits: 2 }) + '\u00a0₪';
  function amountNode(scope) {
    const el = scope.querySelector('[data-limoniapps-discountninja-price-cents-presentmentcurrency]');
    return el && el.getAttribute('data-currency') === 'ILS' && Number(el.getAttribute('data-limoniapps-discountninja-price-cents-presentmentcurrency')) === AMOUNT;
  }
  function comparison(root, productID) {
    const card = root.closest('.spf-product-card');
    if (card) {
      const formID = card.querySelector('input[name="product-id"]');
      const select = card.querySelector('select.spf-product__variants');
      const selected = select && select.selectedOptions[0];
      if (!formID || formID.value !== productID || !selected || !/^\d+$/.test(selected.value)) return null;
      const normal = minor(selected.getAttribute('data-price'));
      const compare = minor(selected.getAttribute('data-compare_at_price'));
      if (normal === null || normal < AMOUNT) return null;
      return { normal, compare: compare !== null && compare > normal && compare > AMOUNT ? compare : null, variantID: selected.value };
    }
    if (String(config.productID) !== productID) return null;
    const scope = root.closest('.product-single-wrapper');
    const input = scope && scope.querySelector('product-form:not(.spf-product__form) input.product-variant-id[name="id"]');
    const variant = input && variants.get(input.value);
    if (!variant || !Number.isSafeInteger(variant.price) || variant.price < AMOUNT) return null;
    return { normal: variant.price, compare: Number.isSafeInteger(variant.compare) && variant.compare > variant.price && variant.compare > AMOUNT ? variant.compare : null, variantID: String(variant.id) };
  }
  function clearPrice(root) {
    root.classList.remove('ingo-election-price-presented');
    root.querySelectorAll('.ingo-election-price-line').forEach(el => el.remove());
    delete root.dataset.ingoElectionVariant;
  }
  function present(root) {
    const card = root.closest('.spf-product-card');
    const appRoot = card ? root.querySelector(ROOT + '[data-token="' + TOKEN + '"]') : root;
    const discounted = appRoot && appRoot.querySelector('[data-la-dn-shortcode-product="DISCOUNTED_PRICE"]');
    const nativeBadge = card && card.querySelector(BADGE + '[data-token="' + TOKEN + '"]');
    const formID = card && card.querySelector('input[name="product-id"]');
    const productID = card ? formID && formID.value : discounted && discounted.getAttribute('data-la-dn-product');
    const priceProof = appRoot && appRoot.dataset.token === TOKEN && discounted && discounted.getAttribute('data-la-dn-product') === productID && amountNode(discounted);
    const badgeProof = nativeBadge && amountNode(nativeBadge);
    const data = allowed() && (priceProof || badgeProof) && comparison(root, productID);
    if (!data) { clearPrice(root); return; }
    // Remove our own panel if the app moved it into its hidden native-original clone.
    root.querySelectorAll('.ingo-election-price-line').forEach(el => { if (el.parentElement !== root) el.remove(); });
    // Display only. Never touch native variant options, input prices or app financial data.
    const directLines = root.querySelectorAll(':scope > .ingo-election-price-line');
    directLines.forEach((el, index) => { if (index > 0) el.remove(); });
    let line = directLines[0];
    if (!line) {
      line = document.createElement('span');
      line.className = 'ingo-election-price-line';
      line.setAttribute('dir', 'ltr');
      const old = document.createElement('del');
      old.className = 'ingo-election-compare';
      const current = document.createElement('span');
      current.className = 'ingo-election-current';
      line.append(old, current);
      root.appendChild(line);
    }
    const old = line.querySelector('.ingo-election-compare');
    const current = line.querySelector('.ingo-election-current');
    const oldText = data.compare === null ? '' : money(data.compare);
    if (old.textContent !== oldText) old.textContent = oldText;
    if (old.hidden !== (data.compare === null)) old.hidden = data.compare === null;
    if (current.textContent !== money(AMOUNT)) current.textContent = money(AMOUNT);
    const label = (data.compare === null ? '' : 'מחיר מקורי ' + oldText + ', ') + 'מחיר מבצע ' + money(AMOUNT);
    if (line.getAttribute('aria-label') !== label) line.setAttribute('aria-label', label);
    if (root.dataset.ingoElectionVariant !== data.variantID) root.dataset.ingoElectionVariant = data.variantID;
    if (!root.classList.contains('ingo-election-price-presented')) root.classList.add('ingo-election-price-presented');
  }
  function badge(root) {
    const ok = allowed() && root.dataset.token === TOKEN && amountNode(root);
    if (!ok) {
      root.classList.remove('ingo-election-badge-presented');
      root.querySelectorAll('.ingo-election-badge-label').forEach(el => el.remove());
      return;
    }
    let label = root.querySelector(':scope > .ingo-election-badge-label');
    if (!label) {
      label = document.createElement('span');
      label.className = 'ingo-election-badge-label';
      label.setAttribute('dir', 'ltr');
      label.textContent = '-89₪';
      root.appendChild(label);
    }
    if (!root.classList.contains('ingo-election-badge-presented')) root.classList.add('ingo-election-badge-presented');
  }
  function scan() {
    document.querySelectorAll('.spf-product-card__price-wrapper').forEach(present);
    document.querySelectorAll(ROOT + '[data-token="' + TOKEN + '"]').forEach(root => {
      if (!root.closest('.spf-product-card')) present(root);
    });
    document.querySelectorAll('.ingo-election-price-presented').forEach(root => {
      if (!root.isConnected || (!root.matches('.spf-product-card__price-wrapper') && root.dataset.token !== TOKEN)) clearPrice(root);
    });
    document.querySelectorAll(BADGE + '[data-token="' + TOKEN + '"], .ingo-election-badge-presented').forEach(badge);
  }
  let queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; scan(); });
  }
  const observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-token','data-currency','data-limoniapps-discountninja-price-cents-presentmentcurrency','value','selected','data-price','data-compare_at_price'] });
  document.addEventListener('change', schedule, true);
  document.addEventListener('click', schedule, true);
  document.addEventListener('visibilitychange', schedule);
  window.addEventListener('pageshow', schedule);
  window.setInterval(schedule, 30000);
  scan();
})();
